namespace GeniuzPOS.PriceChange {
    export interface ActivePriceChangeRow {
        Id?: number;
        EffectiveDate?: string;
        PluCode?: string;
        PluName?: string;
        StyleId?: string;
        ColorId?: string;
        SizeId?: string;
        TasteId?: string;
        MatTypeId?: string;
        SkuCode?: string;
        CatCode?: string;
        SubCat1Code?: string;
        SubCat2Code?: string;
        BrandCode?: string;
        SellUnitPrice1Fg?: boolean;
        SellUnitPrice2Fg?: boolean;
        SellUnitPrice3Fg?: boolean;
        SellUnitPrice4Fg?: boolean;
        SellUnitPrice5Fg?: boolean;
        SellUnitPrice6Fg?: boolean;
        SellUnitPrice1?: number;
        SellUnitPrice2?: number;
        SellUnitPrice3?: number;
        SellUnitPrice4?: number;
        SellUnitPrice5?: number;
        SellUnitPrice6?: number;
        ApproveFg?: ApproveFgSelect;
        PostFg?: PostFgStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ApproveBy?: string;
        Approvedate?: string;
        ActiveBy?: string;
        Activedate?: string;
    }

    export namespace ActivePriceChangeRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PluCode';
        export const localTextPrefix = 'PriceChange.ActivePriceChange';
        export const lookupKey = 'PriceChange.ActivePriceChange';

        export function getLookup(): Q.Lookup<ActivePriceChangeRow> {
            return Q.getLookup<ActivePriceChangeRow>('PriceChange.ActivePriceChange');
        }
        export const deletePermission = '1POSBASE:การเปลี่ยนราคาขาย:Active:Modify';
        export const insertPermission = '1POSBASE:การเปลี่ยนราคาขาย:Active:Modify';
        export const readPermission = '1POSBASE:การเปลี่ยนราคาขาย:Active:View';
        export const updatePermission = '1POSBASE:การเปลี่ยนราคาขาย:Active:Modify';

        export declare const enum Fields {
            Id = "Id",
            EffectiveDate = "EffectiveDate",
            PluCode = "PluCode",
            PluName = "PluName",
            StyleId = "StyleId",
            ColorId = "ColorId",
            SizeId = "SizeId",
            TasteId = "TasteId",
            MatTypeId = "MatTypeId",
            SkuCode = "SkuCode",
            CatCode = "CatCode",
            SubCat1Code = "SubCat1Code",
            SubCat2Code = "SubCat2Code",
            BrandCode = "BrandCode",
            SellUnitPrice1Fg = "SellUnitPrice1Fg",
            SellUnitPrice2Fg = "SellUnitPrice2Fg",
            SellUnitPrice3Fg = "SellUnitPrice3Fg",
            SellUnitPrice4Fg = "SellUnitPrice4Fg",
            SellUnitPrice5Fg = "SellUnitPrice5Fg",
            SellUnitPrice6Fg = "SellUnitPrice6Fg",
            SellUnitPrice1 = "SellUnitPrice1",
            SellUnitPrice2 = "SellUnitPrice2",
            SellUnitPrice3 = "SellUnitPrice3",
            SellUnitPrice4 = "SellUnitPrice4",
            SellUnitPrice5 = "SellUnitPrice5",
            SellUnitPrice6 = "SellUnitPrice6",
            ApproveFg = "ApproveFg",
            PostFg = "PostFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ApproveBy = "ApproveBy",
            Approvedate = "Approvedate",
            ActiveBy = "ActiveBy",
            Activedate = "Activedate"
        }
    }
}
